module.exports = __webpack_public_path__ + "img/zinc_gallery_4.d1c926ba.jpg";